// Keeping the sidebar honest after an ENTITY change.
//
// Deleting the last task / note / event / email out of an ongoing hides that ongoing server-side
// (it is derived, so restoring the entity brings it straight back). No ongoing endpoint was called,
// so the store has to work out what moved by comparing the list before and after.

// The ids that were in the list before and are not in it now — the ongoings this change just hid.
export function vanishedIds(before, after) {
  const stillThere = new Set((after || []).map(o => (o && typeof o === 'object' ? o.id : o)))
  return (before || [])
    .map(o => (o && typeof o === 'object' ? o.id : o))
    .filter(id => id && !stillThere.has(id))
}

// The member timelines an ongoing delete just cleared, as the BFF's `DELETE ongoing/{id}` answers
// them ({ deleted, orphanedTimelineIds }). Anything else — an older BFF that still answers a bare
// `true`, a failed call, a malformed body — reads as "no ids", and the caller falls back to its
// re-fetch. Ids are strings here: the panel's rows carry them as strings too.
export function orphanedTimelineIds(response) {
  const ids = response?.data?.orphanedTimelineIds
  if (!Array.isArray(ids)) return []
  return ids.filter(id => typeof id === 'string' && id.trim()).map(id => id.trim())
}

// The ids that are back in the list — a restore must clear their tombstones, or the 90s suppression
// would keep an ongoing the user just brought back off the screen.
export function returnedIds(deletedIds, after) {
  const back = new Set((after || []).map(o => (o && typeof o === 'object' ? o.id : o)))
  return (deletedIds || []).map(d => (d && typeof d === 'object' ? d.id : d)).filter(id => back.has(id))
}
